!function(factory){"use strict";"function"==typeof define&&define.amd?define(["jquery"],factory):jQuery&&!jQuery.fn.hoverIntent&&factory(jQuery)}(function($){"use strict";var cX,cY,_cfg={interval:100,sensitivity:6,timeout:0},INSTANCE_COUNT=0,track=function(ev){cX=ev.pageX,cY=ev.pageY},compare=function(ev,$el,s,cfg){if(Math.sqrt((s.pX-cX)*(s.pX-cX)+(s.pY-cY)*(s.pY-cY))<cfg.sensitivity)return $el.off(s.event,track),delete s.timeoutId,s.isActive=!0,ev.pageX=cX,ev.pageY=cY,delete s.pX,delete s.pY,cfg.over.apply($el[0],[ev]);s.pX=cX,s.pY=cY,s.timeoutId=setTimeout(function(){compare(ev,$el,s,cfg)},cfg.interval)},delay=function(ev,$el,s,out){return delete $el.data("hoverIntent")[s.id],out.apply($el[0],[ev])};$.fn.hoverIntent=function(handlerIn,handlerOut,selector){var instanceId=INSTANCE_COUNT++,cfg=$.extend({},_cfg);$.isPlainObject(handlerIn)?(cfg=$.extend(cfg,handlerIn),$.isFunction(cfg.out)||(cfg.out=cfg.over)):cfg=$.isFunction(handlerOut)?$.extend(cfg,{over:handlerIn,out:handlerOut,selector:selector}):$.extend(cfg,{over:handlerIn,out:handlerIn,selector:handlerOut});var handleHover=function(e){var ev=$.extend({},e),$el=$(this),hoverIntentData=$el.data("hoverIntent");hoverIntentData||$el.data("hoverIntent",hoverIntentData={});var state=hoverIntentData[instanceId];state||(hoverIntentData[instanceId]=state={id:instanceId}),state.timeoutId&&(state.timeoutId=clearTimeout(state.timeoutId));var mousemove=state.event="mousemove.hoverIntent.hoverIntent"+instanceId;if("mouseenter"===e.type){if(state.isActive)return;state.pX=ev.pageX,state.pY=ev.pageY,$el.off(mousemove,track).on(mousemove,track),state.timeoutId=setTimeout(function(){compare(ev,$el,state,cfg)},cfg.interval)}else{if(!state.isActive)return;$el.off(mousemove,track),state.timeoutId=setTimeout(function(){delay(ev,$el,state,cfg.out)},cfg.timeout)}};return this.on({"mouseenter.hoverIntent":handleHover,"mouseleave.hoverIntent":handleHover},cfg.selector)}});
$(document).ready(function() {

  $(document).on("swell:initialized", function() {
    $('.swell-initialized-loader').remove();
    SwellConfig.Redemption.initializeRedemptions(".swell-redemption-option-list-fixed");
  });

  $(document).on("swell:setup", function() {
    Swell.Campaign.initializeCampaigns(".swell-campaign-list", SwellConfig.Campaign.opts);
    SwellConfig.Campaign.addLogoCampaign(".swell-campaign-list");
    SwellConfig.Campaign.authenticate();
    SwellConfig.Campaign.grayOutCompleted();
    Swell.Redemption.initializeProductRedemptions(".swell-product-redemption-option-list", SwellConfig.Redemption.opts(".swell-product-redemption-option-list"));
    if (spapi.authenticated && spapi.customer.tags.includes("swell_vip_wild")) {
      spapi.setupBuyProductWithPointsHelper();
    }
    SwellConfig.Redemption.applyProductSlickSlider(".swell-product-redemption-option-list");
    SwellConfig.Tier.initializeDummyTier();
    SwellConfig.Tier.initializeCustomTierProperties();
    SwellConfig.Tier.initializeTiers(".vip-earn-table");
    SwellConfig.Tier.setupStatus('.vip-earn-table');
    $('.swell-tier-list').slick('refresh');

    $(".swell-referral-loader").remove();

  });
    SwellConfig.Link.initializeLinks(".swell-link-list .sign-up-btn, .swell-link-list .log-in");
});

(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Campaign = {
    opts: {
      templates: {
        campaign: '<li class="swell-campaign"> <div class="swell-campaign-content add-hover" data-display-mode="modal" data-campaign-id="<%= campaign.id %>"> <div class="swell-campaign-icon"> <span class="swell-campaign-icon-content swell-complete"> <i class="<%= campaign.icon %>_complete"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span><span class="path7"></span></i> </span> <span class="swell-campaign-icon-content swell-incomplete"> <i class="<%= campaign.icon %>_incomplete"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span><span class="path7"></span></i> </span> <span class="swell-campaign-icon-content swell-hover"> <i class="<%= campaign.icon %>_hover"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span><span class="path7"></span></i> </span> </div> <div class="swell-campaign-value"><span class="swell-campaign-value-content"><%= campaign.reward_text %></span></div> <div class="swell-campaign-type"><span class="swell-campaign-type-content"><%= campaign.title %></span></div> </div> </li>',
        campaignHover: '<div class="swell-campaign-hover"> <div class="swell-campaign-hover-content"> <ul class="swell-link-list"> <li class="swell-link"> <a href="/account/login" class="log-in">Sign In</a> </li> <li class="swell-link"> <a href="/account/register" class="sign-up-btn">Sign Up</a> </li> </ul> </div> </div>'
      }
    },
    authenticate: function() {
      if (!spapi.authenticated) {
        spapi.$(document).off("click", ".swell-campaign-content");
        return $(".swell-campaign-content").hover(function() {
          return $(this).append(SwellConfig.Campaign.opts.templates.campaignHover);
        }, function() {
          return $(this).find(".swell-campaign-hover").remove();
        });
      }
    },
    addLogoCampaign: function(containerSelector){
      $(containerSelector).append('<li class="swell-campaign custom-campaign"> <div class="swell-campaign-content add-hover" data-campaign-id="-1"> <div class="swell-campaign-logo"> <img src="https://cdn.shopify.com/s/files/1/0235/8415/files/Main_Website_Logo_Horizontal_632x136.svg?v=1651473541" </div> </div> </li>')
      $(containerSelector).find('.swell-campaign .swell-campaign-content[data-campaign-id="556183"]').parent().remove();
      $(containerSelector).find('.swell-campaign .swell-campaign-content[data-campaign-id="556184"]').parent().remove();
    },
    grayOutCompleted:function(){
      if (spapi.authenticated) {
        campaigns = spapi.activeCampaigns;
        campaigns.forEach(function(campaign){
          if(campaign.customerCompleted){
            $('.swell-campaign .swell-campaign-content[data-campaign-id="'+campaign.id+'"] .swell-campaign-icon .swell-campaign-icon-content.swell-incomplete').css("display","none");
            $('.swell-campaign .swell-campaign-content[data-campaign-id="'+campaign.id+'"] .swell-campaign-icon .swell-campaign-icon-content.swell-complete').css("display","inline-block");
          }
        });
        if(spapi.customer.birthday != null){
          $('.swell-campaign .swell-campaign-content[data-campaign-id="556174"] .swell-campaign-icon .swell-campaign-icon-content.swell-incomplete').css("display","none");
          $('.swell-campaign .swell-campaign-content[data-campaign-id="556174"] .swell-campaign-icon .swell-campaign-icon-content.swell-complete').css("display","inline-block");
        }
      }
    }
  };

}).call(this);

(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Redemption = {
    initializeRedemptions: function(conntainerSelector){
      var activator = "";
      if ($(conntainerSelector).hasClass("logged-in")) {
        activator = "";
      }
      spapi.activeRedemptionOptions.forEach(function(redemption){
        if(redemption.discount_type === "fixed_amount"){
          $(conntainerSelector).append('<li class="swell-redemption-option"> <div class="swell-redemption-option-content '+activator+'" data-redemption-option-id="'+ redemption.id +'"> <div class="swell-redemption-option-details"> <div class="swell-redemption-option-cost "> <div class="swell-header-details">'+(redemption.name.replace(" Off", ""))+'</div> </div> <div class="swell-redemption-option-value"> <div class="swell-details">'+redemption.cost_text+'</div> </div> </div> </div> </li>');
        }
      });
    },
    opts: function(conntainerSelector){
      var activator = "";
      if (spapi.authenticated && spapi.customer.tags.includes("swell_vip_wild")) {
        activator = "swell-buy-product-btn";
        spapi.setupBuyProductWithPointsHelper();
      }
      return opts = {
         templates : {
          redemptionOptionProduct: '<li class="swell-redemption-option" data-redemption-option-id="<%= redemption.id %>"> <div class="swell-redemption-option-content" data-redemption-option-id="<%= redemption.id %>"> <div class="slide-img-holder"> <img src="<%= redemption.background_image_url %>"> </div> <div class="swell-redemption-option-value"> <%= redemption.name %> </div> <div class="swell-redemption-option-cost" data-variant-id="<%= redemption.applies_to_id %>"> <%= redemption.cost_text %> </div> <div class="swell-link-redeem '+activator+'" data-variant-id="<%= redemption.applies_to_id %>" data-redemption-option-id="<%= redemption.id %>" data-confirm-title="Are you sure?" data-confirm-content="You currently have *|point_balance|* points available. This product costs *|amount|* points to redeem." data-confirm-btn-text="Yes, buy it" data-error-type="red" data-error-title="Whoops!" data-error-content="Looks like you don\'t have enough points for this product. This product costs *|amount|* points and you only have *|point_balance|* points available." data-error-okay-text="Ok" data-success-type="green" data-success-title="Success!" data-success-content="Product was successfully added to your cart" data-success-ok-btn="Keep Shopping" data-success-cart-btn="View Cart" data-success-cart-link="/cart">Redeem Now</div> </div> </li>'
        }
      }
    },
    applyProductSlickSlider : function(containerSelector){
      if ($(containerSelector).length === 0) {
        return "";
      }
      $(containerSelector).slick({
        infinite: false,
        dots: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 4,
        centerMode: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true,
              arrows: true,
            }
          }
       ]
      });
    }
  };

}).call(this);

(function() {
  window.SwellConfig = window.SwellConfig || {};
  SwellConfig.Tier = {
    getTierById : function(id) {
      var tiers;
      tiers = spapi.activeVipTiers;
      return $.grep(tiers, function(e) {
        return e.id === id;
      })[0];
    },
    getTierByRank: function(rank) {
      var tiers;
      tiers = spapi.activeVipTiers;
      return $.grep(tiers, function(e) {
        return e.rank === rank;
      })[0];
    },
    initializeDummyTier: function() {
      var k, len, tier, tiers;
      tiers = spapi.activeVipTiers;
      for (k = 0, len = tiers.length; k < len; k++) {
        tier = tiers[k];
        tier.rank += 1;
      }
      return tiers.unshift({
        id: -1,
        rank: 0,
        dummy: true,
        name: "Happy",
        points: "$0&ndash;$299",
        points_multiplier:" 1",
        exclusive_products: "",
        free_product: "",
        amount_spent_cents: 0,
        referrals_completed: 0,
        points_earned: 0,
        purchases_made: 0,
      });
    },
    initializeCustomTierProperties: function() {
      var tiers = spapi.activeVipTiers;
        Tier_0 = SwellConfig.Tier.getTierByRank(0);
        Tier_1 = SwellConfig.Tier.getTierByRank(1);
        Tier_2 = SwellConfig.Tier.getTierByRank(2);
        
      if(Tier_0){
        Tier_0.spend = "$"+(Tier_0.amount_spent_cents/100)+" - $"+((Tier_1.amount_spent_cents/100)-1)+"<br>Spent per rolling year";
        Tier_0.point_multiplier = "1x Points"; 
        Tier_0.birthday_reward = "25 Points";
        Tier_0.one_time_coupon = ""; 
        
        Tier_0.early_Bonus_Points_Events = "<img style='width:25px;' src='//thehappyplanner.com/cdn/shop/t/226/assets/disc-pink.png?v=136458147299971727791781641343'>";
        Tier_0.Exclusive_MembersOnly_Offers = "<img style='width:25px;' src='//thehappyplanner.com/cdn/shop/t/226/assets/disc-pink.png?v=136458147299971727791781641343'>";
        Tier_0.early_New_Releases_Promotions = "";
        Tier_0.Exclusive_Product_Redemption = ""; 
        Tier_0.Free_Shipping_Promotions = ""; 
        Tier_0.Special_Mystery_Products = ""; 
        
        Tier_0.class = "tier_0";
      }
      if(Tier_1){
        Tier_1.spend = "$"+(Tier_1.amount_spent_cents/100)+" - $"+((Tier_2.amount_spent_cents/100)-1)+"<br>Spent per rolling year"; 
        Tier_1.point_multiplier = "1.25x Points"; 
        Tier_1.birthday_reward = "50 Points";
        Tier_1.one_time_coupon = "15% Off";
        
        Tier_1.early_Bonus_Points_Events = "<img style='width:25px;' src='//thehappyplanner.com/cdn/shop/t/226/assets/disc-pink.png?v=136458147299971727791781641343'>";
        Tier_1.Exclusive_MembersOnly_Offers = "<img style='width:25px;' src='//thehappyplanner.com/cdn/shop/t/226/assets/disc-pink.png?v=136458147299971727791781641343'>";
        Tier_1.early_New_Releases_Promotions = "<img style='width:25px;' src='//thehappyplanner.com/cdn/shop/t/226/assets/disc-pink.png?v=136458147299971727791781641343'>";
        Tier_1.Exclusive_Product_Redemption = ""; 
        Tier_1.Free_Shipping_Promotions = ""; 
        Tier_1.Special_Mystery_Products = ""; 
        
        Tier_1.early_access_to_products = "<div>Coming Soon</div>"; 
        Tier_1.exclusive_product_redemption = "";
        Tier_1.class = "tier_1";
      }
      if(Tier_2){
        Tier_2.spend = "$"+(Tier_2.amount_spent_cents/100)+"+<br>Spent per rolling year"; 
        Tier_2.point_multiplier = "1.5x Points"; 
        Tier_2.birthday_reward = "75 Points";
        Tier_2.one_time_coupon = "25% Off";
        
        Tier_2.early_Bonus_Points_Events =    "<img style='width:25px;' src='//thehappyplanner.com/cdn/shop/t/226/assets/disc-pink.png?v=136458147299971727791781641343'>";
        Tier_2.Exclusive_MembersOnly_Offers = "<img style='width:25px;' src='//thehappyplanner.com/cdn/shop/t/226/assets/disc-pink.png?v=136458147299971727791781641343'>";
        Tier_2.early_New_Releases_Promotions = "<img style='width:25px;' src='//thehappyplanner.com/cdn/shop/t/226/assets/disc-pink.png?v=136458147299971727791781641343'>";
        Tier_2.Exclusive_Product_Redemption = "<img style='width:25px;' src='//thehappyplanner.com/cdn/shop/t/226/assets/disc-pink.png?v=136458147299971727791781641343'>"; 
        Tier_2.Free_Shipping_Promotions =  "<img style='width:25px;' src='//thehappyplanner.com/cdn/shop/t/226/assets/disc-pink.png?v=136458147299971727791781641343'>"; 
        Tier_2.Special_Mystery_Products = "<p>Coming Soon</p>"; 
        
        Tier_2.early_access_to_products = ""; 
        Tier_2.early_access_to_productss = "<img style='width:25px;' src='//thehappyplanner.com/cdn/shop/t/226/assets/disc-pink.png?v=136458147299971727791781641343'>"; 
        Tier_2.exclusive_product_redemption = "<div class='circle'></div>";
        Tier_2.class = "tier_2";
      }
    },
    initializeTiers: function(containerSelector) {
      var i, j, key, properties, property, ref, ref1, tiers;
      if ($(containerSelector).length === 0) {
        return "";
      }
      tiers = spapi.activeVipTiers;
      properties = {
        header: {
          spend: {
            className: "swell-tier-values",
            title: ""
          },
          name: {
            className: "swell-tier-names",
            title: "Benefits",
          }
        },
        body: {
          point_multiplier: {
            title: "Per $ Spent"
          },
          birthday_reward: {
            title: "Birthday Reward"
          },
          one_time_coupon: {
            title: "Coupon (one-time use)"
          },
          early_Bonus_Points_Events: {
            title: "<img class='nw_img_badge' src='//thehappyplanner.com/cdn/shop/t/226/assets/new_badge.png?v=2427894355563183111781641358' alt='caption_img'><p class='NEW_icon'>Bonus Points Events <span class='rewardnew_texts'> - <b style='color:#e96ca6;'> NEW!</b></span></p>"
          },
           Exclusive_MembersOnly_Offers: {
            title: "<img class='nw_img_badge' src='//thehappyplanner.com/cdn/shop/t/226/assets/new_badge.png?v=2427894355563183111781641358' alt='caption_img'><p class='NEW_icon'>Exclusive Members-Only Offers <span class='rewardnew_texts'> - <b style='color:#e96ca6;'> NEW!</b></span></p>"
          },
          early_New_Releases_Promotions: {
            title: "<img class='nw_img_badge' src='//thehappyplanner.com/cdn/shop/t/226/assets/new_badge.png?v=2427894355563183111781641358' alt='caption_img'><p class='NEW_icon'>Early Access to New Releases & Promotions <span class='rewardnew_texts'> - <b style='color:#e96ca6;'> NEW!</b></span></p>"
          },
          
          
            Exclusive_Product_Redemption: {
            title: "Exclusive Product Redemption"
          },
          
           Free_Shipping_Promotions: {
            title: "<img class='nw_img_badge' src='//thehappyplanner.com/cdn/shop/t/226/assets/new_badge.png?v=2427894355563183111781641358' alt='caption_img'><p class='NEW_icon'>Free Shipping Promotions <span class='rewardnew_texts'> - <b style='color:#e96ca6;'>NEW!</b></span></p>"
          },
          
            Special_Mystery_Products: {
            title: "Special Mystery Products (Redeemable With Points)"
          }
          
        }
      };
      $(containerSelector).append('<li class="swell-tier-benefit"><div class="swell-tier-holder"> </div></li>');
      $(containerSelector).append('<li class="swell-tier-properties"><ul class="swell-tier-list">  </ul></li>');
      tiers.forEach(function(tier) {
        return $(containerSelector).find(".swell-tier-properties .swell-tier-list").append('<li class="swell-tier '+tier.class+'" data-tier-id="' + tier.id + '"> <div class="swell-tier-holder"> </div> </li>');
      });
      j = 0;
      ref = properties.header;
      for (key in ref) {
        property = ref[key];
        $(containerSelector).find(".swell-tier-benefit .swell-tier-holder").append('<div class="swell-tier-items ' + property.className + '"> ' + property.title + '</div>');
        tiers.forEach(function(tier) {
          return $(containerSelector).find('.swell-tier-properties .swell-tier-list .swell-tier[data-tier-id="'+ tier.id +'"] .swell-tier-holder').append('<div class="swell-tier-items ' + property.className + '"> ' + tier[key] + '</div>');
        });+
        j++;
      }
      i = 0;
      ref1 = properties.body;
      for (key in ref1) {
        property = ref1[key];
        $(containerSelector).find(".swell-tier-benefit .swell-tier-holder").append('<div class="swell-tier-items"> ' + property.title + '</div>');
        tiers.forEach(function(tier) {
          return $(containerSelector).find('.swell-tier-properties .swell-tier-list .swell-tier[data-tier-id="'+ tier.id +'"] .swell-tier-holder').append('<div class="swell-tier-items"> ' + tier[key] + '</div>');
        });
        i++;
      }
      SwellConfig.Tier.applytierSlickSlider('.swell-tier-list');
    },
    setupStatus: function(containerSelector){
      if(spapi.authenticated){
        tiers = spapi.activeVipTiers;
        $(containerSelector).find(".swell-tier-benefit").prepend('<div class="swell-tier-status"></div>');
        tiers.forEach(function(tier){
          $(containerSelector).find('.swell-tier-properties .swell-tier-list .swell-tier[data-tier-id="'+ tier.id +'"]').prepend('<div class="swell-tier-status"></div>');
        });

        if(spapi.customer.vip_tier){
          if(SwellConfig.Tier.getTierById(spapi.customer.vip_tier.id).rank < tiers.length-1){
            next_tier = SwellConfig.Tier.getTierByRank(SwellConfig.Tier.getTierById(spapi.customer.vip_tier.id).rank+1);
            $(containerSelector).find('.swell-tier-properties .swell-tier-list .swell-tier[data-tier-id="'+spapi.customer.vip_tier.id+'"] .swell-tier-status').append('<div class="current-status">Current status <div class="vip-star"><img src="//thehappyplanner.com/cdn/shop/t/226/assets/swell-vip-star.svg?v=170542785607391652931781641440"</div></div>');
            required = (spapi.customer.vip_tier_stats_needed.amount_cents_needed/100);
            $(containerSelector).find('.swell-tier-properties .swell-tier-list .swell-tier[data-tier-id="'+next_tier.id+'"] .swell-tier-status').append('<div class="tier-encouragement">Spend $'+required+' more</div>');  
          }
          else{
            $(containerSelector).find('.swell-tier-properties .swell-tier-list .swell-tier[data-tier-id="'+spapi.customer.vip_tier.id+'"] .swell-tier-status').append('<div class="current-status">Current status <div class="vip-star"><img src="//thehappyplanner.com/cdn/shop/t/226/assets/swell-vip-star.svg?v=170542785607391652931781641440"</div></div>'); 
          }
          $(containerSelector).find('.swell-tier-properties .swell-tier-list .swell-tier[data-tier-id="'+spapi.customer.vip_tier.id+'"]').addClass("swell-active");
        }else{
          $(containerSelector).find('.swell-tier-properties .swell-tier-list .swell-tier[data-tier-id="'+SwellConfig.Tier.getTierByRank(0).id+'"] .swell-tier-status').append('<div class="current-status">Current status <div class="vip-star"><img src="//thehappyplanner.com/cdn/shop/t/226/assets/swell-vip-star.svg?v=170542785607391652931781641440"</div></div>');
          required = (spapi.customer.vip_tier_stats_needed.amount_cents_needed/100);
          $(containerSelector).find('.swell-tier-properties .swell-tier-list .swell-tier[data-tier-id="'+ SwellConfig.Tier.getTierByRank(1).id+'"] .swell-tier-status').append('<div class="tier-encouragement">Spend $'+required+' more</div>');  
        }
        $(containerSelector).addClass('swell-status');
      }
    },
    applytierSlickSlider: function(containerSelector){
      $(containerSelector).slick({
        dots: true,
        infinite: false,
        speed: 300,
        slidesToScroll: 1,
        slidesToShow: 3,
        responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
          }
        }
        ]
      });
    }
  };
}).call(this);

window.onBeforeProductRedemption = function(opts, redemptionOption, pointBalance, cb) {
  var redeemedItemsInCart = 0;
  var regularItemsInCart = 0;
  var discountInCart = 0;
  var already_product = false;
  if(Swell.Cart && Swell.Cart.items) {
    var cart = Swell.Cart;
    $.each(cart.items, function(index, item){
      if(item.properties._swell_points_used){
        redeemedItemsInCart++;
        if(redemptionOption.id == item.properties._swell_redemption_option_id)
        {
          already_product = true;
        }
      } else if(item.line_price > 0){
        regularItemsInCart++;
      }
    });
    
    if(regularItemsInCart == 0 || already_product){
      if(regularItemsInCart == 0)
      {
        content = "You must add a priced item in your cart to redeem points for a free product."
      }
      else if(already_product)
      {
        content = "Product is already added to your cart."
      }
      spapi.$.confirm({
        title: "Oops!",
        type: "red",
        content: content,
        typeAnimated: true,
        useBootstrap: false,
        boxWidth: "400px",
        buttons: {
          ok: {
            text: "Ok",
            action: function () {
            }
          }
        }
      });
    } else {
      cb();   
    }
  }
};

(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Link = {
    initializeLinks: function(containerSelector) {
      return $(document).on("click", containerSelector, function(e) {
        var href;
        e.preventDefault();
        href = $(this).attr("href");
        localStorage.setItem("swell-location", "/pages/rewards");
        return window.location = href;
      });
    }
  };

}).call(this);
